import React from "react";
import BlogTwentyOne from "../component/BlogTwentyOne";

function BlogTwentyOneContainer() {
  return <BlogTwentyOne />;
}
export default BlogTwentyOneContainer;
